import { OptionType } from "@portal/BaseComponents/CheckBox/type";
import {
  CustomFieldInValues,
  CustomFieldOptions,
  CustomFiledMultiSelectValues,
} from "@portal/types/entities/custom-field";
import {
  filterUnassigned,
  stringConverterPredicate,
} from "@portal/util/predicates";
import { MultiSelectElement } from "../../MultiSelect/MultiSelectElement";
import { getCustomFieldNonNumberOptions } from "../predicate";

export interface CustomFieldMultiSelectProps {
  options: CustomFieldOptions;
  allSearch?: boolean;
  onSubmit: (value: CustomFiledMultiSelectValues) => void;
  initialValue: CustomFieldInValues;
  shouldIncludeUnassigned?: boolean;
  onCancel: () => void;
}

function CustomFieldMultiSelect(props: CustomFieldMultiSelectProps) {
  const {
    options,
    initialValue,
    onSubmit,
    shouldIncludeUnassigned = true,
    onCancel,
  } = props;
  const customFieldOptions = getCustomFieldNonNumberOptions(options);

  function handleSubmit(value: OptionType["value"][]) {
    const selectedValue = value?.filter(filterUnassigned) ?? [];
    const unassigned = value?.includes("-1");
    const selectedValues: CustomFiledMultiSelectValues = {
      operator: {
        type: "IN",
        operands: {
          type: "DEPRECATED_ABSOLUTE",
          value: selectedValue.map(stringConverterPredicate),
        },
      },
      include_unassigned: unassigned ?? false,
    };
    onSubmit(selectedValues);
  }

  return (
    <MultiSelectElement
      multiSelectProps={{
        options: customFieldOptions,
        onSubmit: handleSubmit,
        onCancel,
        initialValue,
        shouldIncludeUnassigned,
      }}
      search={{
        type: "local",
        placeholder: "Search Custom Fields",
      }}
    />
  );
}

export { CustomFieldMultiSelect };
